const $ = require('jquery');

var FloatingLabels = function (el) {
  this.init(el);
};

FloatingLabels.prototype.init = function (el) {
  this.$el = $(el);
  this.$label = this.$el.find('label');
  this.$field = this.$el.find('input, textarea, select');
  var _this = this;

  this.$field.blur(function () {
    if (_this.$field.val()) {
      _this.$field.attr('data-hasvalue', 'true');
    } else {
      _this.$field.removeAttr('data-hasvalue');
    }
  });

  this.$field.change(function () {
    if (_this.$field.val()) {
      _this.$field.attr('data-hasvalue', true);
    } else {
      _this.$field.removeAttr('data-hasvalue');
    }
  });
};

$(document).ready(function(){
  $('.itbl-input-wrap__floating_label').each(function(){
    new FloatingLabels(this);
  });
});
